import { useState } from "react";
import { Button, ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface Props {
  warnings: (string | null | undefined)[];
  editWarning?: string | null;
  retryDisabled: boolean;
  onRetryEdit: () => void;
}

export const StepOrderWarning = ({ warnings, editWarning, retryDisabled, onRetryEdit }: Props) => {
  const [hovered, setHovered] = useState(false);
  const [pinned, setPinned] = useState(false);
  const close = () => { setHovered(false); setPinned(false); };

  return (
    <ClickAwayListener mouseEvent="onMouseDown" onClickAway={close}>
      <span onClick={(event) => event.stopPropagation()} onKeyDown={(event) => {
        if (event.key === "Escape") { event.stopPropagation(); close(); }
      }}>
        <Tooltip
          arrow
          disableInteractive={false}
          open={hovered || pinned}
          onOpen={() => setHovered(true)}
          onClose={() => setHovered(false)}
          title={
            <div dir="rtl" className="max-w-xs p-1">
              <div className="whitespace-pre-line">{warnings.filter(Boolean).join("\n")}</div>
              {editWarning ? (
                <Button
                  variant="contained"
                  size="small"
                  className="!mt-2"
                  disabled={retryDisabled}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (retryDisabled) return;
                    close();
                    onRetryEdit();
                  }}
                >
                  تلاش مجدد ویرایش
                </Button>
              ) : null}
            </div>
          }
        >
          <IconButton
            size="small"
            aria-label="هشدار سفارش"
            aria-expanded={hovered || pinned}
            onClick={() => setPinned(!pinned)}
          >
            <WarningAmberIcon className="text-amber-600" fontSize="small" />
          </IconButton>
        </Tooltip>
      </span>
    </ClickAwayListener>
  );
};
